import { FileTray } from 'react-ionicons';

export const EmptySupportRequests = () => {
  return (
    <div className="col-span-full flex flex-col items-center gap-6 bg-background-base-surface-2 p-8">
      <FileTray
        color="rgb(var(--content-base-subdued))"
        width="48px"
        height="48px"
      />
      <p className="rounded font-bold leading-[22px] text-content-base-default">
        You do not have any support requests.
      </p>
    </div>
  );
};
